// Axios
import axios from 'axios';

// Configuration
import { BASE_URL, ORCHESTRATION_SERVICE, SERVICE_VERSION } from './configuration';

// Endpoints
import { ORCHESTRATION_ENDPOINT } from './configuration/orchestration-service';

// Store
import store from '../store';

export const ORCHESTRATION_SERVICE_URL = `${BASE_URL}/${ORCHESTRATION_SERVICE}/${SERVICE_VERSION}`;

export const getProductOrderId = (reqPayload) => () => {
  return axios
    .post(
      `${ORCHESTRATION_SERVICE_URL}${ORCHESTRATION_ENDPOINT.CREATE_ORDER}`,
      reqPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-tenant':
            store.getState().UserServiceReducer?.csmTenants?.tenantId ??
            process.env.REACT_APP_SELLER_TENANT_ID,
          buyerUserId: reqPayload?.userDetails?.userId
        }
      }
    )
    .then((response) => {
      return response?.data;
    });
};

export const getCartProductDetails = (reqPayload) => (dispatch) => {
  dispatch({
    type: 'SET_LOADER',
    payload: true
  });
  return axios
    .post(
      `${ORCHESTRATION_SERVICE_URL}${ORCHESTRATION_ENDPOINT.VALIDATE_PRODUCT_TENANT}`,
      reqPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          'X-tenant':
            store.getState().UserServiceReducer?.csmTenants?.tenantId ??
            process.env.REACT_APP_SELLER_TENANT_ID
        },
        params: {
          productPublishedTenant:
            store.getState().UserServiceReducer?.csmTenants?.tenantId
        }
      }
    )
    .then((response) => {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'GET_CART_PRODUCT_DETAILS',
        payload: response.data
      });
      return response.data;
    })
    .catch((error) => {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'ERROR',
        error: error
      });
    });
};

export const saveCheckoutId = (reqPayload) => () => {
  return axios.post(
    `${ORCHESTRATION_SERVICE_URL}${ORCHESTRATION_ENDPOINT.SAVE_CHECKOUT}`,
    reqPayload,
    {
      headers: {
        'Content-Type': 'application/json',
        'X-tenant':
          store.getState().UserServiceReducer?.csmTenants?.tenantId ??
          process.env.REACT_APP_SELLER_TENANT_ID,
        buyerUserId: reqPayload?.userDetails?.userId
      }
    }
  );
};
